<template>
    <div class="favorite-channel-item" :class="rootClasses" @click="emitClick">
        <div class="favorite-channel-item__mark" :class="markClassList">
            <common-icon :icon-name="'IconStar'" />
        </div>
        <div class="favorite-channel-item__number">{{ number }}</div>
        <div class="favorite-channel-item__icon" :style="iconStyles" />
        <div class="favorite-channel-item__name">{{ name }}</div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType, computed, type StyleValue } from "vue";
    import { Channel } from "@ca.vmedia.tv/domains";

    const emit = defineEmits(['click']);
    const props = defineProps({
        isChecked: {
                type: Boolean,
                default: false,
                required: true,
            },
            isFocused: {
                type: Boolean,
                default: false,
                required: true,
            },
            item: {
                type: Object as PropType<Channel>,
                default: new Channel(),
                required: true,
            },
    });

    const number = computed((): string => props.item?.accessNum?.toString() ?? "");
    const name = computed((): string => props.item?.name ?? "");
    const markClassList = computed((): {[key: string]: boolean} => {
        return {
            ['favorite-channel-item__mark_is-checked']: props.isChecked
        }
    });
    const iconStyles = computed((): StyleValue => {
        return {
            backgroundImage: `url(${props.item.image})`,
        };
    });
    const rootClasses = computed((): {[key: string]: boolean} => {
        return {
            ['favorite-channel-item_is-focused']: props.isFocused
        };
    });

    const emitClick = (event: MouseEvent): void =>{
        emit("click", event);
    }
</script>

<style lang="scss">
    @import url("styles.scss");
</style>
